import React from "react";
import { CheckCircleTwoTone, InfoCircleTwoTone } from "@ant-design/icons";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";

const SuccessPopup = ({ open, onClose, message, navigate }) => {
  const isAlreadyExists = message?.toLowerCase().includes("already");
  const Navigate = useNavigate();
  const handleOk = () => {
    onClose();
    if (navigate) {
      Navigate(navigate);
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      bodyStyle={{ textAlign: "center", padding: 30 }}
    >
      {isAlreadyExists ? (
        <InfoCircleTwoTone
          twoToneColor="#faad14"
          style={{ fontSize: 80, marginBottom: 20 }}
        />
      ) : (
        <CheckCircleTwoTone
          twoToneColor="#52c41a"
          style={{ fontSize: 80, marginBottom: 20 }}
        />
      )}

      <h2 style={{ marginBottom: 10 }}>
        {isAlreadyExists ? "Information" : "Success"}
      </h2>

      <p style={{ fontSize: 16 }}>{message}</p>

      <button
        onClick={handleOk}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          background: isAlreadyExists ? "#faad14" : "#52c41a",
          border: "none",
          color: "#fff",
          borderRadius: 6,
          cursor: "pointer",
        }}
      >
        OK
      </button>
    </Modal>
  );
};

export default SuccessPopup;
